export const REQUIRED_FIELDS = {
  PROJECT_NAME: "Project name is required",
  ESTIMATED_START_DATE: "Estimated start date is required",
  ESTIMATED_END_DATE: "Estimated end date is required",
  CATEGORY: "Category is required",
  TYPE: "Project type is required",
  CLIENT_NAME: "Client name is required",
  CLIENT_EMAIL: "Client email is required",
  CLIENT_PHONE: "Client Mobile is required",
  CLIENT_ADDRESS: "Client address is required",
  INVALID_EMAIL: "Invalid email format",
  WAREHOUSE: "Warehouse selection is required",
  STATUS: "Status is required",
};

export const VALIDATION_MESSAGES = {
  VALID_NUMBER: "Client phone must be a valid number",
  START_DATE: "Start Date cannot be in the past",
  END_DATE: "Estimated End Date cannot be in the past",
};

export const PROJECT_TYPES = [
  { value: "SOLAR", label: "Solar" },
  { value: "EV", label: "EV" },
  { value: "OTHER", label: "Other" },
];

export const CATEGORY_TYPES = [
  { value: "RESIDENTIAL", label: "Residential" },
  { value: "COMMERCIAL", label: "Commercial" },
  { value: "INDUSTRIAL", label: "Industrial" },
  { value: "OTHER", label: "Other" },
];

export const PROJECT_FILTER_TYPES = [
  { value: "all", label: "All Projects" },
  { value: "my", label: "My Projects" },
];

export const PROJECT_FILTER_TYPES_VALUES = {
  SITE_ENGINEER: "my",
  PROJECT_ENGINEER: "all",
  PROJECT_MANAGER: "all",
  GOVERNMENT_OFFICER: "all",
  HEAD_OFFICE: "all",
  MANAGING_DIRECTOR: "all",
};

export const TOAST_MESSAGES = {
  PROJECT_FETCH_FAILED: "Failed To Load Projects..",
  PROJECT_CREATED: "Project created successfully",
  PROJECT_CREATION_FAILED: "Project creation failed",
  PROJECT_CREATION_ERROR: "An error occurred while creating the project",
  PROJECT_GET_DETAILS_ERROR: "An error occurred while fetching project details",
  PROJECT_DETAILS_FETCHED: "Project details fetched successfully",
  GRN_FETCH_FAILED: "Failed To Load GRNs",
  DELETE_GRN_SUCCESS: "GRN deleted successfully",
  GRN_CREATION_FAILED: "GRN creation failed",
  GRN_CREATED: "GRN created successfully",
  FETCH_GRN_FAILED: "Failed to fetch GRN details",
  GRN_UPDATED: "GRN updated",
  GRN_UPDATING_FAILED: "GRN updating failed",
  GRN_DETAIL_FETCHED: "GRN details fetched",
  MRR_GRN_FETCH_FAILED: "MRR-GRN related data fetch failed",
  MRR_DN_FETCH_FAILED: "MRR-DN related data fetch failed",
  
};

export const PROJECT_STATUS = [
  { value: "PENDING", label: "Not Started" },
  { value: "IN_PROGRESS", label: "In Progress" },
  { value: "COMPLETED", label: "Completed" },
];

export const PROJECT_LIST_PAGE_COLUMNS = [
  "name",
  "client_name",
  "type",
  "category",
  "status",
  "completion_percentage",
];

export const PROJECT_LIST_PAGE_LABELS = {
  name: "Project Name",
  client_name: "Client Name",
  type: "Type",
  category: "Category",
  status: "Status",
  completion_percentage: "Completion(%)",
};

export const NO_PROJECTS_FOUND = "No projects found.";

export const PROJECT_DETAILS_TABS = [
  { label: "Details", value: "details" },
  { label: "Users", value: "users" },
  { label: "Files", value: "files" },
  { label: "Sites", value: "sites" },
];

export const LABEL_MAPPINGS = {
  type: PROJECT_TYPES,
  category: CATEGORY_TYPES,
};

export const PROJECT_STATUS_LABELS = PROJECT_STATUS.reduce((acc, s) => {
  acc[s.value] = s.label;
  return acc;
}, {});

export const STATUS_STYLES = PROJECT_STATUS.reduce(
  (acc, s) => {
    if (s.value === "PENDING") acc[s.value] = "bg-yellow-100 text-yellow-700";
    if (s.value === "IN_PROGRESS") acc[s.value] = "bg-blue-100 text-blue-700";
    if (s.value === "COMPLETED") acc[s.value] = "bg-green-100 text-green-700";
    return acc;
  },
  { default: "bg-red-100 text-red-700" }
);
